import logo from './logo.svg';
import './App.css';
import Header from './Components/HeaderNavs/Header';
import About from './Components/Pages/About/About';
import { Route, Routes } from "react-router-dom";
import Home from './Components/Home/Home';
import Skills from './Components/Skills/Skills';
import Projects from './Components/Projects/Projects';
import Contact from './Components/Pages/Contact/Contact';
import { Center } from '@chakra-ui/react';
import Navbar from './Components/HeaderNavs/Navbar';
import { Toaster } from 'react-hot-toast';
import Footer from './Components/Footer/Footer';
// import Contact from './Components/Pages/Contact/Contact';

function App() {
  return (
    <div className="min-h-screen flex flex-col bg-zinc-50 dark:bg-zinc-900 text-zinc-800 dark:text-zinc-200 relative">
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/skills" element={<Skills />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Center className="sticky bottom-0 bg-zinc-50 dark:bg-zinc-900 p-2 z-40 w-full">
        <Navbar small={true} />
      </Center>
      <Footer />
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
